import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/design-system/components/ds/icon';
import type { MaterialSymbolName } from '@repo/design-system/types/material-symbol-names';
import { css, cx } from '@repo/panda/css';
import type React from 'react';
type ExploreActionHeaderIconTone = 'nearby' | 'checklist' | 'heroAction';
interface ExploreActionHeaderIconProps {
  icon: MaterialSymbolName;
  tone: ExploreActionHeaderIconTone;
  ariaLabel?: string;
  disabled?: boolean;
  fill?: boolean;
  title?: string;
  onClick?: () => void;
}
const headerIconStyles = css({
  width: '[48px]',
  height: '[48px]',
  minWidth: '[48px]',
  minHeight: '[48px]',
  borderRadius: 'full',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxShadow: 'sm',
  backdropFilter: '[blur(8px)]',
  border: 'none'
});
const interactiveHeaderIconStyles = css({
  cursor: 'pointer',
  transition: '[transform 0.1s ease]',
  _hover: {
    transform: 'scale(1.05)'
  },
  _focusVisible: {
    outline: '[2px solid]',
    outlineColor: 'blue.500',
    outlineOffset: '2'
  },
  _disabled: {
    cursor: 'default',
    _hover: {
      transform: 'none'
    }
  }
});
const toneStyles: Record<ExploreActionHeaderIconTone, React.CSSProperties> = {
  nearby: {
    backgroundColor: 'var(--colors-white)',
    color: 'var(--colors-black)'
  },
  checklist: {
    backgroundColor: 'var(--colors-white)',
    color: 'var(--colors-black)'
  },
  heroAction: {
    backgroundColor: 'var(--colors-brand-primary)',
    color: 'var(--colors-black)'
  }
};
export const ExploreActionHeaderIcon: React.FC<ExploreActionHeaderIconProps> = t0 => {
  const $ = _c(18);
  const {
    icon,
    tone,
    ariaLabel,
    disabled: t1,
    fill: t2,
    title,
    onClick
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  const fill = t2 === undefined ? false : t2;
  const style = toneStyles[tone];
  const t3 = onClick && interactiveHeaderIconStyles;
  let t4;
  if ($[0] !== t3) {
    t4 = cx(headerIconStyles, t3);
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const className = t4;
  let t5;
  if ($[2] !== fill || $[3] !== icon) {
    t5 = <Icon icon={icon} fill={fill} size="lg" decorative={true} />;
    $[2] = fill;
    $[3] = icon;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const iconElement = t5;
  if (onClick) {
    let t6;
    if ($[5] !== ariaLabel || $[6] !== className || $[7] !== disabled || $[8] !== iconElement || $[9] !== onClick || $[10] !== style || $[11] !== title) {
      t6 = <button type="button" className={className} style={style} onClick={onClick} title={title} aria-label={ariaLabel} disabled={disabled}>{iconElement}</button>;
      $[5] = ariaLabel;
      $[6] = className;
      $[7] = disabled;
      $[8] = iconElement;
      $[9] = onClick;
      $[10] = style;
      $[11] = title;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t6;
  if ($[13] !== className || $[14] !== iconElement || $[15] !== style || $[16] !== title) {
    t6 = <div className={className} style={style} title={title}>{iconElement}</div>;
    $[13] = className;
    $[14] = iconElement;
    $[15] = style;
    $[16] = title;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  return t6;
};